module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"facebook_meta_tag":"Facebook domain meta-tag verification","facebook_meta_tag_text":"Copy and paste your facebook meta-tag\u0027s content in fields below"},"id":{"facebook_meta_tag":"Verfikasi domain meta-tag Facebook","facebook_meta_tag_text":"Salin dan tempel konten meta-tag facebook kamu di bawah ini"}}')
  delete Component.options._Ctor
}
